import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { DatePipe } from '@angular/common';
import { FilterService, IFilterSubject } from '../../services/filter.service';
import { filter } from 'rxjs';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'split-filter-year',
  templateUrl: './split-filter-year.component.html',
  styleUrls: ['./split-filter-year.component.scss']
})
export class SplitFilterYearComponent {
  @Input() data: IFilterData[] = [];

  @Input() field!: string;

  @Input() label!: string;

  @Input() key!: string;

  @Input() groupId!: string;

  protected _data: any = undefined;

  protected filterModel!: IFilterModel;


  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  @ViewChild('op') public overlayPanel!: OverlayPanel;
  isActiveOverlay: boolean = false;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.filters = this.filterModel;

    this.filterService.filterSubject.pipe(
      filter((data: IFilterSubject) => data.action === "CLEAR"),
      filter((event: IFilterSubject) => event.id === this.groupId)
    ).subscribe(
      (data: IFilterSubject) => {
        this._data = undefined;
        this.onEmit();
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
   if(changes["data"]) {
     this._data = this.copy();
   }  

   if(changes["key"]) {
    this.filterModel = {
      id: this.groupId,
      type: "YEAR",
      key: this.key,
      data: [],
      filter: []
    }
   }
  }

  copy() {
    return this.data[0] ? new Date(this.data[0].name) : undefined;
  }

  showOverlayPanel(event: any) {
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  hideOverlayPanel() {
    this._data = this.copy();
    this.isActiveOverlay = false;
  }

  onCancel() {
    this._data = undefined;
    this.onEmit();
    this.overlayPanel.hide();
  }

  onEmit() { 
    let filter: IFilter[] = [];
    let data: IFilterData[] = [];
    if(this._data) {
      data = [{id: this._data, name: this._data}] as IFilterData[];
      filter = [
        {
          key: this.key,
          fields: ["after"],
          property: this.field,
          value: this.tranformDateInString(this._data)
        },
        {
          key: this.key,
          fields: ["before"],
          property: this.field,
          value: this.tranformDateInString(this._data)
        }
      ];
    }

    let filterModel: IFilterModel  = {
      ...this.filterModel,
      data: data,
      filter: filter
    };
    this.data = filterModel.data;
    this.filterService.send(filterModel);
    this.onFilterEvent.emit(filterModel);
    this.overlayPanel.hide();
  }



  tranformDateInString(date?: Date) {
    return new DatePipe("pt-BR").transform(date, 'yyyy-MM-dd') as string;
  }

  isValidDate(date: Date){
    return date.toString() !== 'Invalid Date';
  }
}
